"use strict";
const allButtonsAssinar = document.querySelectorAll('.cacm-produto-card__botao-assinar');
const minicart = document.querySelector('.cacm-minicartassinatura');
const botaoFecharMinicart = document.querySelector('.cacm-minicartassinatura__fechar');
const toast = document.getElementById('cacm-toast');
const carrinhoOffcanvas = document.getElementById('cacm-carrinho-offcanvas');
const botaoFecharCarrinho = document.getElementById('cacm-carrinho-fechar');
const botaoVerCarrinho = document.querySelector('.cacm-minicartassinatura__botao');
const containerProdutosCarrinho = document.getElementById('cacm-carrinho-produtos');
const totalCarrinho = document.getElementById('cacm-carrinho-total');
const itensCarrinho = document.getElementById('cacm-carrinho-itens');
const botaoAssinarCarrinho = document.querySelector('.cacm-carrinho-offcanvas__botao-assinar');
const barraProgressoCarrinho = document.querySelector('.cacm-carrinho-offcanvas__progresso-barra');
const textoProgressoCarrinho = document.querySelector('.cacm-carrinho-offcanvas__progresso-texto');
const barraProgressoMinicart = document.querySelector('.cacm-minicartassinatura__progresso-barra');
const preenchimentoProgressoMinicart = document.querySelector('.cacm-minicartassinatura__progresso-preenchimento');
const textoProgressoMinicart = document.querySelector('.cacm-minicartassinatura__progresso-texto');
const resumoMinicart = document.querySelector('.cacm-minicartassinatura__resumo-valor');
class Produto {
    id;
    nome;
    preco;
    precoOriginal;
    imagem;
    quantidade;
    constructor(id, nome, preco, precoOriginal, imagem, quantidade) {
        this.id = id;
        this.nome = nome;
        this.preco = preco;
        this.precoOriginal = precoOriginal;
        this.imagem = imagem;
        this.quantidade = quantidade;
    }
}
let casrtAssinatura = [];
function salvarCarrinhoNoSessionStorage() {
    try {
        sessionStorage.setItem('carrinhoAssinaturaAnual', JSON.stringify(casrtAssinatura));
    }
    catch (error) {
        console.error('Erro ao salvar carrinho no sessionStorage:', error);
    }
}
function recuperarCarrinhoDoSessionStorage() {
    try {
        const carrinhoSalvo = sessionStorage.getItem('carrinhoAssinaturaAnual');
        if (carrinhoSalvo) {
            const produtosRecuperados = JSON.parse(carrinhoSalvo);
            return produtosRecuperados.map((produto) => new Produto(produto.id, produto.nome, produto.preco, produto.precoOriginal, produto.imagem, produto.quantidade));
        }
    }
    catch (error) {
        console.error('Erro ao recuperar carrinho do sessionStorage:', error);
    }
    return [];
}
function construirMapaAnualPorVariantId() {
    const mapa = {};
    const cards = document.querySelectorAll('.cacm-produto-card');
    cards.forEach((card) => {
        const idAnual = card.getAttribute('data-id');
        if (!idAnual)
            return;
        const nome = card.querySelector('.cacm-produto-card__nome')?.textContent || '';
        const preco = card.querySelector('.cacm-produto-card__preco-atual')?.textContent || '';
        const precoOriginal = card.querySelector('.cacm-produto-card__preco-original')?.textContent || '';
        const img = card.querySelector('.cacm-produto-card__imagem');
        const imagem = img ? img.getAttribute('src') || '' : '';
        mapa[String(idAnual)] = { id: idAnual, nome, preco, precoOriginal, imagem };
    });
    return mapa;
}
function aplicarCarrinhoMigrado() {
    try {
        const raw = sessionStorage.getItem('carrinhoMigracaoMensalParaAnual');
        if (!raw)
            return false;
        const itens = JSON.parse(raw);
        if (!Array.isArray(itens) || itens.length === 0) {
            sessionStorage.removeItem('carrinhoMigracaoMensalParaAnual');
            return false;
        }
        const mapa = construirMapaAnualPorVariantId();
        casrtAssinatura = [];
        itens.forEach((item) => {
            const dados = mapa[String(item.id)];
            if (!dados)
                return;
            const existente = casrtAssinatura.find((p) => p.id === dados.id);
            const qty = String(item.quantidade || 1);
            if (existente) {
                existente.quantidade = String(parseInt(existente.quantidade, 10) + parseInt(qty, 10));
            }
            else {
                casrtAssinatura.push(new Produto(dados.id, dados.nome, dados.preco, dados.precoOriginal, dados.imagem, qty));
            }
        });
        sessionStorage.removeItem('carrinhoMigracaoMensalParaAnual');
        salvarCarrinhoNoSessionStorage();
        return true;
    }
    catch (e) {
        console.error('Erro ao aplicar carrinho migrado:', e);
        sessionStorage.removeItem('carrinhoMigracaoMensalParaAnual');
        return false;
    }
}
function mostrarToast(mensagem) {
    const toastMessage = toast.querySelector('.cacm-toast__message');
    toastMessage.textContent = mensagem;
    toast.classList.add('show');
    setTimeout(() => {
        toast.classList.remove('show');
    }, 3000);
}
function desabilitarBotaoTemporariamente(botao, tempo = 2000) {
    botao.setAttribute('disabled', 'true');
    botao.textContent = 'Adicionando...';
    setTimeout(() => {
        botao.removeAttribute('disabled');
        botao.textContent = 'Assinar';
    }, tempo);
}
function mostrarMinicart() {
    if (minicart) {
        minicart.style.display = 'block';
        atualizarMinicart();
    }
}
function fecharMinicart() {
    if (minicart) {
        minicart.style.display = 'none';
    }
}
function atualizarContadorHeader(totalItens) {
    if (contadorCarrinhoHeader) {
        contadorCarrinhoHeader.textContent = totalItens.toString();
        if (totalItens > 0) {
            contadorCarrinhoHeader.classList.add('show');
        }
        else {
            contadorCarrinhoHeader.classList.remove('show');
        }
    }
}
function atualizarMinicart() {
    const totalItens = casrtAssinatura.reduce((total, produto) => total + parseInt(produto.quantidade), 0);
    const totalPreco = casrtAssinatura.reduce((total, produto) => {
        const precoProduto = parseFloat(produto.preco.replace('R$', '').replace(',', '.').trim());
        const quantidade = parseInt(produto.quantidade);
        return total + (precoProduto * quantidade);
    }, 0);
    const valorMeta = 119.90;
    atualizarContadorHeader(totalItens);
    if (resumoMinicart) {
        resumoMinicart.textContent = `12x R$ ${totalPreco.toFixed(2).replace('.', ',')} / ${totalItens} itens`;
    }
    if (barraProgressoMinicart && preenchimentoProgressoMinicart && textoProgressoMinicart) {
        const percentualProgresso = Math.min((totalPreco / valorMeta) * 100, 100);
        preenchimentoProgressoMinicart.style.width = `${percentualProgresso}%`;
        preenchimentoProgressoMinicart.style.display = 'block';
        preenchimentoProgressoMinicart.style.opacity = '1';
        preenchimentoProgressoMinicart.style.visibility = 'visible';
        const valorRestante = Math.max(valorMeta - totalPreco, 0);
        if (totalPreco >= valorMeta) {
            textoProgressoMinicart.textContent = '🎉 PARABÉNS 🎉 - Agora você está apto para o nosso plano anual';
            textoProgressoMinicart.classList.add('parabens');
        }
        else {
            textoProgressoMinicart.textContent = `Faltam R$${valorRestante.toFixed(2).replace('.', ',')} /mês para assinar o ESPECIAL`;
            textoProgressoMinicart.classList.remove('parabens');
        }
    }
    if (botaoVerCarrinho) {
        const hiperlinkDiscreto = minicart.querySelector('.cacm-minicartassinatura__hiperlink-discreto');
        if (totalPreco >= valorMeta) {
            botaoVerCarrinho.textContent = 'ASSINAR';
            botaoVerCarrinho.style.backgroundColor = '#A95D1A';
            botaoVerCarrinho.style.color = 'white';
            if (hiperlinkDiscreto) {
                hiperlinkDiscreto.style.display = 'block';
            }
        }
        else {
            botaoVerCarrinho.textContent = 'Ver carrinho';
            botaoVerCarrinho.style.backgroundColor = '#BDDF39';
            botaoVerCarrinho.style.color = '#0a0a0a';
            if (hiperlinkDiscreto) {
                hiperlinkDiscreto.style.display = 'none';
            }
        }
    }
}
function montarUrlCarrinho() {
    const baseUrl = 'https://coffeemais.com/cart/';
    const itemFixo = '45195341496476:1';
    const parametros = casrtAssinatura.map(item => `${item.id}:${item.quantidade}`).join(',');
    const urlFinal = baseUrl + itemFixo + ',' + parametros;
    // + "?discount=KITASSANUAL"
    return urlFinal;
}
function abrirCarrinho() {
    if (carrinhoOffcanvas) {
        carrinhoOffcanvas.classList.add('show');
        renderizarProdutosCarrinho();
        setTimeout(() => {
            verificarConteudoAdicional();
        }, 400);
        setTimeout(() => {
            verificarConteudoAdicional();
        }, 800);
    }
}
function fecharCarrinho() {
    if (carrinhoOffcanvas) {
        carrinhoOffcanvas.classList.remove('show');
    }
}
function renderizarProdutosCarrinho() {
    if (!containerProdutosCarrinho)
        return;
    containerProdutosCarrinho.innerHTML = '';
    if (casrtAssinatura.length === 0) {
        containerProdutosCarrinho.innerHTML = '<p style="color: #999; text-align: center; padding: 20px;">Carrinho vazio</p>';
        atualizarResumoCarrinho();
        return;
    }
    casrtAssinatura.forEach((produto, index) => {
        const itemElement = document.createElement('div');
        itemElement.className = 'cacm-carrinho-item';
        itemElement.setAttribute('data-index', index.toString());
        itemElement.innerHTML = `
            <div class="cacm-carrinho-item__coluna-foto">
                <img src="${produto.imagem}" alt="${produto.nome}" class="cacm-carrinho-item__imagem">
            </div>
            <div class="cacm-carrinho-item__coluna-nome">
                <div class="cacm-carrinho-item__nome">${produto.nome}</div>
            </div>
            <div class="cacm-carrinho-item__coluna-quantidade">
                <div class="cacm-carrinho-item__quantidade">
                    <button class="cacm-carrinho-item__quantidade-botao" data-action="diminuir">-</button>
                    <span class="cacm-carrinho-item__quantidade-valor">${produto.quantidade}</span>
                    <button class="cacm-carrinho-item__quantidade-botao" data-action="aumentar">+</button>
                </div>
            </div>
        `;
        containerProdutosCarrinho.appendChild(itemElement);
    });
    adicionarEventListenersQuantidadeCarrinho();
    atualizarResumoCarrinho();
    setTimeout(() => {
        verificarConteudoAdicional();
    }, 100);
    setTimeout(() => {
        verificarConteudoAdicional();
    }, 300);
}
function verificarConteudoAdicional() {
    const bodyElement = document.querySelector('.cacm-carrinho-offcanvas__body');
    const footerElement = document.querySelector('.cacm-carrinho-offcanvas__footer');
    if (!bodyElement || !footerElement) {
        return;
    }
    const scrollTop = bodyElement.scrollTop;
    const clientHeight = bodyElement.clientHeight;
    const scrollHeight = bodyElement.scrollHeight;
    const hasScroll = scrollHeight > clientHeight;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
    const remainingScroll = scrollHeight - (scrollTop + clientHeight);
    const hasMoreContentBelow = remainingScroll > 10;
    if (hasScroll && hasMoreContentBelow) {
        footerElement.classList.add('has-more-content');
    }
    else {
        footerElement.classList.remove('has-more-content');
    }
}
function adicionarEventListenersQuantidadeCarrinho() {
    const botoesQuantidade = containerProdutosCarrinho.querySelectorAll('.cacm-carrinho-item__quantidade-botao');
    botoesQuantidade.forEach(botao => {
        botao.addEventListener('click', (e) => {
            const action = e.target.dataset.action;
            const itemElement = e.target.closest('.cacm-carrinho-item');
            const index = parseInt(itemElement?.getAttribute('data-index') || '0');
            if (action === 'aumentar') {
                aumentarQuantidadeCarrinho(index);
            }
            else if (action === 'diminuir') {
                diminuirQuantidadeCarrinho(index);
            }
        });
    });
}
function aumentarQuantidadeCarrinho(index) {
    if (casrtAssinatura[index]) {
        const quantidadeAtual = parseInt(casrtAssinatura[index].quantidade);
        casrtAssinatura[index].quantidade = (quantidadeAtual + 1).toString();
        salvarCarrinhoNoSessionStorage();
        renderizarProdutosCarrinho();
        atualizarMinicart();
        mostrarToast('Quantidade atualizada!');
    }
}
function diminuirQuantidadeCarrinho(index) {
    if (casrtAssinatura[index]) {
        const quantidadeAtual = parseInt(casrtAssinatura[index].quantidade);
        if (quantidadeAtual > 1) {
            casrtAssinatura[index].quantidade = (quantidadeAtual - 1).toString();
            salvarCarrinhoNoSessionStorage();
            renderizarProdutosCarrinho();
            atualizarMinicart();
            mostrarToast('Quantidade atualizada!');
        }
        else {
            casrtAssinatura.splice(index, 1);
            salvarCarrinhoNoSessionStorage();
            renderizarProdutosCarrinho();
            atualizarMinicart();
            mostrarToast('Produto removido do carrinho!');
            if (casrtAssinatura.length === 0) {
                setTimeout(() => {
                    fecharCarrinho();
                }, 1500);
            }
        }
    }
}
function atualizarResumoCarrinho() {
    const totalItens = casrtAssinatura.reduce((total, produto) => total + parseInt(produto.quantidade), 0);
    const totalPreco = casrtAssinatura.reduce((total, produto) => {
        const precoProduto = parseFloat(produto.preco.replace('R$', '').replace(',', '.').trim());
        const quantidade = parseInt(produto.quantidade);
        return total + (precoProduto * quantidade);
    }, 0);
    const valorMeta = 119.90;
    if (totalCarrinho) {
        totalCarrinho.textContent = `R$ ${totalPreco.toFixed(2).replace('.', ',')}`;
    }
    if (itensCarrinho) {
        itensCarrinho.textContent = totalItens.toString();
    }
    if (barraProgressoCarrinho && textoProgressoCarrinho) {
        const percentualProgresso = Math.min((totalPreco / valorMeta) * 100, 100);
        barraProgressoCarrinho.style.setProperty('--progress-width', `${percentualProgresso}%`);
        const valorRestante = Math.max(valorMeta - totalPreco, 0);
        if (totalPreco >= valorMeta) {
            textoProgressoCarrinho.textContent = '🎉 PARABÉNS 🎉 - Agora você está apto para o nosso plano anual!';
            textoProgressoCarrinho.classList.add('parabens');
        }
        else {
            textoProgressoCarrinho.textContent = `Faltam R$ ${valorRestante.toFixed(2).replace('.', ',')} para assinar o ESPECIAL`;
            textoProgressoCarrinho.classList.remove('parabens');
        }
    }
    if (botaoAssinarCarrinho) {
        if (totalPreco >= valorMeta) {
            botaoAssinarCarrinho.removeAttribute('disabled');
            botaoAssinarCarrinho.style.opacity = '1';
            botaoAssinarCarrinho.style.cursor = 'pointer';
            const linkAssinar = botaoAssinarCarrinho.closest('a');
            if (linkAssinar) {
                const urlCarrinho = montarUrlCarrinho();
                linkAssinar.href = urlCarrinho;
            }
        }
        else {
            botaoAssinarCarrinho.setAttribute('disabled', 'true');
            botaoAssinarCarrinho.style.opacity = '0.5';
            botaoAssinarCarrinho.style.cursor = 'not-allowed';
        }
    }
}
allButtonsAssinar.forEach(button => {
    button.addEventListener('click', () => {
        const card = button.closest('.cacm-produto-card');
        if (!card)
            return;
        const produtoId = card.getAttribute('data-id') || '';
        const quantidadeCard = parseInt(card.querySelector('.cacm-produto-card__quantidade-valor')?.textContent || '1');
        const produtoExistente = casrtAssinatura.find(p => p.id === produtoId);
        if (produtoExistente) {
            const quantidadeAtual = parseInt(produtoExistente.quantidade);
            produtoExistente.quantidade = (quantidadeAtual + quantidadeCard).toString();
            salvarCarrinhoNoSessionStorage();
            mostrarToast(`Quantidade atualizada! Total: ${produtoExistente.quantidade}`);
            if (carrinhoOffcanvas && carrinhoOffcanvas.classList.contains('show')) {
                renderizarProdutosCarrinho();
                setTimeout(() => {
                    verificarConteudoAdicional();
                }, 150);
                setTimeout(() => {
                    verificarConteudoAdicional();
                }, 500);
            }
        }
        else {
            const produto = new Produto(produtoId, card.querySelector('.cacm-produto-card__nome')?.textContent || '', card.querySelector('.cacm-produto-card__preco-atual')?.textContent || '', card.querySelector('.cacm-produto-card__preco-original')?.textContent || '', card.querySelector('.cacm-produto-card__imagem')?.getAttribute('src') || '', quantidadeCard.toString());
            casrtAssinatura.push(produto);
            salvarCarrinhoNoSessionStorage();
            mostrarToast('Produto adicionado ao carrinho!');
        }
        mostrarMinicart();
        desabilitarBotaoTemporariamente(button);
    });
});
if (botaoFecharMinicart) {
    botaoFecharMinicart.addEventListener('click', fecharMinicart);
}
if (botaoVerCarrinho) {
    botaoVerCarrinho.addEventListener('click', (e) => {
        e.preventDefault();
        const totalPreco = casrtAssinatura.reduce((total, produto) => {
            const precoProduto = parseFloat(produto.preco.replace('R$', '').replace(',', '.').trim());
            const quantidade = parseInt(produto.quantidade);
            return total + (precoProduto * quantidade);
        }, 0);
        const valorMeta = 119.90;
        if (totalPreco >= valorMeta) {
            const urlCarrinho = montarUrlCarrinho();
            window.location.href = urlCarrinho;
        }
        else {
            abrirCarrinho();
        }
    });
}
if (botaoFecharCarrinho) {
    botaoFecharCarrinho.addEventListener('click', fecharCarrinho);
}
if (carrinhoOffcanvas) {
    const overlay = carrinhoOffcanvas.querySelector('.cacm-carrinho-offcanvas__overlay');
    if (overlay) {
        overlay.addEventListener('click', fecharCarrinho);
    }
    const bodyElement = carrinhoOffcanvas.querySelector('.cacm-carrinho-offcanvas__body');
    if (bodyElement) {
        let scrollTimeout;
        bodyElement.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                verificarConteudoAdicional();
            }, 10);
        });
        window.addEventListener('resize', () => {
            if (carrinhoOffcanvas.classList.contains('show')) {
                setTimeout(() => {
                    verificarConteudoAdicional();
                }, 100);
            }
        });
    }
}
const allButtonsQuantidade = document.querySelectorAll('.cacm-produto-card__quantidade-botao');
allButtonsQuantidade.forEach(button => {
    button.addEventListener('click', () => {
        const container = button.closest('.cacm-produto-card__quantidade-container');
        const valorElement = container?.querySelector('.cacm-produto-card__quantidade-valor');
        let valor = parseInt(valorElement?.textContent || '0');
        if (button.textContent === '+') {
            valor += 1;
        }
        else if (button.textContent === '-') {
            valor -= 1;
            if (valor < 1)
                valor = 1;
        }
        valorElement.textContent = valor.toString();
    });
});
const faqPerguntas = document.querySelectorAll('.cacm-faq-item__pergunta');
faqPerguntas.forEach(pergunta => {
    pergunta.addEventListener('click', () => {
        const faqItem = pergunta.closest('.cacm-faq-item');
        const resposta = faqItem?.querySelector('.cacm-faq-item__resposta');
        const icone = pergunta.querySelector('.cacm-faq-item__icone');
        if (!faqItem || !resposta || !icone)
            return;
        const isExpanded = pergunta.getAttribute('aria-expanded') === 'true';
        faqPerguntas.forEach(outraPergunta => {
            if (outraPergunta !== pergunta) {
                const outroItem = outraPergunta.closest('.cacm-faq-item');
                const outraResposta = outroItem?.querySelector('.cacm-faq-item__resposta');
                const outroIcone = outraPergunta.querySelector('.cacm-faq-item__icone');
                if (outraResposta && outroIcone) {
                    outraPergunta.setAttribute('aria-expanded', 'false');
                    outraResposta.classList.remove('active');
                }
            }
        });
        if (isExpanded) {
            pergunta.setAttribute('aria-expanded', 'false');
            resposta.classList.remove('active');
        }
        else {
            pergunta.setAttribute('aria-expanded', 'true');
            resposta.classList.add('active');
        }
    });
});
const hiperlinkDiscreto = document.querySelector('.cacm-minicartassinatura__hiperlink-discreto');
if (hiperlinkDiscreto) {
    hiperlinkDiscreto.addEventListener('click', (e) => {
        e.preventDefault();
        abrirCarrinho();
    });
}
document.addEventListener('DOMContentLoaded', () => {
    const migrado = aplicarCarrinhoMigrado();
    if (!migrado) {
        casrtAssinatura = recuperarCarrinhoDoSessionStorage();
    }
    atualizarMinicart();
    // Se veio de uma migração do mensal, abre o carrinho off-canvas automaticamente na página anual.
    if (migrado) {
        abrirCarrinho();
    }
    configurarModalProduto();
});
const modalProduto = document.getElementById('cacm-produto-modal');
const botaoFecharModal = document.getElementById('cacm-produto-modal-fechar');
const modalImagem = document.getElementById('cacm-produto-modal-imagem');
const modalTitulo = document.getElementById('cacm-produto-modal-titulo');
const botaoCarrinhoHeader = document.getElementById('cacm-header-carrinho-botao');
const contadorCarrinhoHeader = document.getElementById('cacm-header-carrinho-contador');
function configurarModalProduto() {
    const cardsProduto = document.querySelectorAll('.cacm-produto-card');
    cardsProduto.forEach(card => {
        const imagemContainer = card.querySelector('.cacm-produto-card__imagem-container');
        const titulo = card.querySelector('.cacm-produto-card__nome');
        if (imagemContainer && titulo) {
            const areaClicavel = document.createElement('div');
            areaClicavel.className = 'cacm-produto-card__area-clicavel';
            imagemContainer.parentNode?.insertBefore(areaClicavel, imagemContainer);
            areaClicavel.appendChild(imagemContainer);
            areaClicavel.appendChild(titulo);
            areaClicavel.addEventListener('click', () => {
                abrirModalProduto(card);
            });
        }
        const lupaOverlay = card.querySelector('.cacm-produto-card__lupa-overlay');
        if (lupaOverlay) {
            lupaOverlay.addEventListener('click', (e) => {
                e.stopPropagation();
                abrirModalProduto(card);
            });
        }
    });
}
function addBlur() {
    const allSections = document.querySelectorAll('section');
    allSections.forEach(section => {
        section.classList.add('blur-section');
    });
}
function removeBlur() {
    const allSections = document.querySelectorAll('section');
    allSections.forEach(section => {
        section.classList.remove('blur-section');
    });
}
function abrirModalProduto(card) {
    const imagem = card.querySelector('.cacm-produto-card__imagem');
    const titulo = card.querySelector('.cacm-produto-card__nome');
    const productId = card.getAttribute('data-id');
    if (modalImagem && modalTitulo && imagem && titulo) {
        modalImagem.src = imagem.src;
        modalImagem.alt = imagem.alt;
        modalTitulo.textContent = titulo.textContent;
        if (productId) {
            carregarMetafieldsProduto(productId);
        }
        modalProduto.classList.add('show');
        document.body.style.overflow = 'hidden';
        addBlur();
    }
}
async function carregarMetafieldsProduto(productId) {
    try {
        const card = document.querySelector(`[data-id="${productId}"]`);
        if (card) {
            const metafields = {
                descricao_curta: card.getAttribute('data-descricao-curta') || 'Não informado',
                regiao: card.getAttribute('data-regiao') || 'Não informado',
                notas_sensoriais: card.getAttribute('data-notas-sensoriais') || 'Não informado',
                torra: card.getAttribute('data-torra') || 'Não informado',
                variedade: card.getAttribute('data-variedade') || 'Não informado',
                descricao_completa: card.getAttribute('data-descricao-completa') || 'Não informado'
            };
            atualizarCamposModalComMetafields(metafields);
        }
        else {
            atualizarCamposModalComProduto({});
        }
    }
    catch (error) {
        console.error('Erro ao carregar metafields:', error);
        atualizarCamposModalComProduto({});
    }
}
function atualizarCamposModalComMetafields(metafields) {
    const descricaoCurta = document.getElementById('cacm-produto-modal-descricao-curta');
    const regiao = document.getElementById('cacm-produto-modal-regiao');
    const notas = document.getElementById('cacm-produto-modal-notas');
    const torra = document.getElementById('cacm-produto-modal-torra');
    const tipo = document.getElementById('cacm-produto-modal-tipo');
    const descricaoCompleta = document.getElementById('cacm-produto-modal-descricao');
    if (descricaoCurta) {
        const descricao = metafields.descricao_curta;
        descricaoCurta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição do produto será carregada aqui.'}</p>`;
    }
    if (regiao) {
        regiao.textContent = metafields.regiao;
    }
    if (notas) {
        notas.textContent = metafields.notas_sensoriais;
    }
    if (torra) {
        torra.textContent = metafields.torra;
    }
    if (tipo) {
        tipo.textContent = metafields.variedade;
    }
    if (descricaoCompleta) {
        const descricao = metafields.descricao_completa;
        descricaoCompleta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição completa do produto será carregada aqui.'}</p>`;
    }
}
function atualizarCamposModalComProduto(product) {
    const descricaoCurta = document.getElementById('cacm-produto-modal-descricao-curta');
    const regiao = document.getElementById('cacm-produto-modal-regiao');
    const notas = document.getElementById('cacm-produto-modal-notas');
    const torra = document.getElementById('cacm-produto-modal-torra');
    const tipo = document.getElementById('cacm-produto-modal-tipo');
    const descricaoCompleta = document.getElementById('cacm-produto-modal-descricao');
    const getMetafield = (namespace, key) => {
        if (product.metafields) {
            const metafield = product.metafields.find((m) => m.namespace === namespace && m.key === key);
            return metafield ? metafield.value : 'Não informado';
        }
        return 'Não informado';
    };
    if (descricaoCurta) {
        const descricao = getMetafield('custom', 'descricao_curta');
        descricaoCurta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição do produto será carregada aqui.'}</p>`;
    }
    if (regiao) {
        regiao.textContent = getMetafield('custom', 'regiao');
    }
    if (notas) {
        notas.textContent = getMetafield('custom', 'notas_sensoriais');
    }
    if (torra) {
        torra.textContent = getMetafield('custom', 'torra');
    }
    if (tipo) {
        tipo.textContent = getMetafield('custom', 'tipo');
    }
    if (descricaoCompleta) {
        const descricao = getMetafield('custom', 'descricao_completa');
        descricaoCompleta.innerHTML = `<p>${descricao !== 'Não informado' ? descricao : 'Descrição completa do produto será carregada aqui.'}</p>`;
    }
}
function fecharModalProduto() {
    modalProduto.classList.remove('show');
    removeBlur();
    document.body.style.overflow = '';
}
if (botaoFecharModal) {
    botaoFecharModal.addEventListener('click', fecharModalProduto);
}
if (modalProduto) {
    const overlay = modalProduto.querySelector('.cacm-produto-modal__overlay');
    if (overlay) {
        overlay.addEventListener('click', fecharModalProduto);
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalProduto.classList.contains('show')) {
            fecharModalProduto();
        }
    });
}
if (botaoCarrinhoHeader) {
    botaoCarrinhoHeader.addEventListener('click', () => {
        abrirCarrinho();
    });
}
